import { UserRole } from './community-auth-interfaces';

export interface Me {
  family_name: string;
  given_name: string;
  email: string;
  level: 'none' | 'email_verified' | 'staff_verified';
  role: UserRole;
  hasOwnerRole: boolean;
  picture: string;
  state: USAStateEnum;
  isCommunityManager: boolean
}

export enum USAStateEnum {
  Alabama = 'alabama',
  Alaska = 'alaska',
  Arizona = 'arizona',
  Arkansas = 'arkansas',
  California = 'california',
  Colorado = 'colorado',
  Connecticut = 'connecticut',
  Delaware = 'delaware',
  DistrictOfColumbia = 'district of columbia',
  Florida = 'florida',
  Georgia = 'georgia',
  Hawaii = 'hawaii',
  Idaho = 'idaho',
  Illinois = 'illinois',
  Indiana = 'indiana',
  Iowa = 'iowa',
  Kansas = 'kansas',
  Kentucky = 'kentucky',
  Louisiana = 'louisiana',
  Maine = 'maine',
  Maryland = 'maryland',
  Massachusetts = 'massachusetts',
  Michigan = 'michigan',
  Minnesota = 'minnesota',
  Mississippi = 'mississippi',
  Missouri = 'missouri',
  Montana = 'montana',
  Nebraska = 'nebraska',
  Nevada = 'nevada',
  NewHampshire = 'new hampshire',
  NewJersey = 'new jersey',
  NewMexico = 'new mexico',
  NewYork = 'new york',
  NorthCarolina = 'north carolina',
  NorthDakota = 'north dakota',
  Ohio = 'ohio',
  Oklahoma = 'oklahoma',
  Oregon = 'oregon',
  Pennsylvania = 'pennsylvania',
  PuertoRico = 'puerto rico',
  RhodeIsland = 'rhode island',
  SouthCarolina = 'south carolina',
  SouthDakota = 'south dakota',
  Tennessee = 'tennessee',
  Texas = 'texas',
  Utah = 'utah',
  Vermont = 'vermont',
  Virginia = 'virginia',
  Washington = 'washington',
  WestVirginia = 'west virginia',
  Wisconsin = 'wisconsin',
  Wyoming = 'wyoming',
}

export const EDUCATIONAL_MATERIALS_STATES: USAStateEnum[] = [
  USAStateEnum.Colorado,
  USAStateEnum.Oregon,
];
